module.exports = __webpack_public_path__ + "static/img/login_left.209404d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_left.png
// module id = JpIM
// module chunks = 94